import { Option } from 'models/Global';
import { BuyerCountKeys } from 'router/subrouters/Dash/subrouters/private/subrouters/Portfolio/subrouters/Buyer/models';

const EXCLUDE_PRIVATE_VIEWERS =
  '"isPrivateViewer": false, "isRequestedPrivateViewer": false';

const EXCLUDE_WITHDRAWN_AND_PRIVATE_VIEWERS = `"withdrawnInterest": false, ${EXCLUDE_PRIVATE_VIEWERS}`;

const ENQUIRE_LISTINGS_QUERY = `[{${EXCLUDE_WITHDRAWN_AND_PRIVATE_VIEWERS}, "buyerStep": "enquire"}]`;

const ACCEEPT_LISTING_QUERY = `[{${EXCLUDE_WITHDRAWN_AND_PRIVATE_VIEWERS}, "buyerStep": "accept"}]`;

const CONFIRM_LISTING_QUERY = `[{${EXCLUDE_WITHDRAWN_AND_PRIVATE_VIEWERS}, "buyerStep": "confirm"}]`;

const OFFER_LISTING_QUERY = `[{${EXCLUDE_WITHDRAWN_AND_PRIVATE_VIEWERS}, "buyerStep": "offer"}]`;

const WITHDRAWN_LISTING_QUERY = `[{"withdrawnInterest": true, ${EXCLUDE_PRIVATE_VIEWERS}}]`;

export const BUYING_ALL_LISTINGS_QUERY = `[{${EXCLUDE_PRIVATE_VIEWERS}}]`;

export const buyerFilterOptions: Option[] = [
  {
    label: 'all',
    value: BUYING_ALL_LISTINGS_QUERY,
  },
  {
    label: 'enquiry',
    value: ENQUIRE_LISTINGS_QUERY,
  },
  {
    label: 'accepted',
    value: ACCEEPT_LISTING_QUERY,
  },
  {
    label: 'prospect',
    value: CONFIRM_LISTING_QUERY,
  },
  {
    label: 'bidder',
    value: OFFER_LISTING_QUERY,
  },
  {
    label: 'withdrawn',
    value: WITHDRAWN_LISTING_QUERY,
  },
];

export const COUNT_VALUES_MAP: Record<string, BuyerCountKeys> = {
  [BUYING_ALL_LISTINGS_QUERY]: 'all',
  [ENQUIRE_LISTINGS_QUERY]: 'totalEnquiredListings',
  [ACCEEPT_LISTING_QUERY]: 'totalAcceptedListings',
  [CONFIRM_LISTING_QUERY]: 'totalConfirmedListings',
  [OFFER_LISTING_QUERY]: 'totalOfferedListings',
  [WITHDRAWN_LISTING_QUERY]: 'totalWithdrawnListings',
} as const;
